import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PresignedurlHandlerService {
  constructor(private http: HttpClient) {}

  public getpresignedUrl(
    mode: 'export_center_data' | 'export_zipfile',
    paramsObj: {
      bucketKey?: string;
      plant?: string;
      station?: string;
      id?: string;
      fileextension?: string;
    } = {},
  ): Observable<string> {
    const apiUrl = environment.restApiUrl + '/images/presignedurl';
    let params = new HttpParams().set('mode', mode);

    if (mode === 'export_center_data' && paramsObj.bucketKey) {
      params = params.set('bucketKey', paramsObj.bucketKey);
    }
    if (mode === 'export_zipfile') {
      if (paramsObj.plant) params = params.set('plant', paramsObj.plant);
      if (paramsObj.station) params = params.set('station', paramsObj.station);
      if (paramsObj.id) params = params.set('id', paramsObj.id);
      if (paramsObj.fileextension)
        params = params.set('fileextension', paramsObj.fileextension);
    }
    return this.http
      .get<{ presigned_url: string }>(apiUrl, { params })
      .pipe(map((response) => response.presigned_url));
  }
}
